<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" v-bind:href="'#t1'+rowData.cotacao_id+''" role="tab" data-toggle="tab">
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.cotacao_id+''" role="tab" data-toggle="tab" v-if="rowData.obs!==null">
                    <span class="nav-link-in">
                      Obs.
                      <i class="fa fa-comment"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t3'+rowData.cotacao_id+''" role="tab" data-toggle="tab" v-if="rowData.cotacao_trecho.length>0">
                    <span class="nav-link-in">
                      Trecho
                      <i class="fa fa-map"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t4'+rowData.cotacao_id+''" role="tab" data-toggle="tab" v-if="rowData.cotacao_doc.length>0">
                    <span class="nav-link-in">
                      Doc.
                      <i class="fa fa-file-text-o"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t5'+rowData.cotacao_id+''" role="tab" data-toggle="tab" v-if="rowData.cotacao_contato.length>0">
                    <span class="nav-link-in">
                      Contato.
                      <i class="fa fa-phone"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t6'+rowData.cotacao_id+''" role="tab" data-toggle="tab" v-if="rowData.cotacao_carga!==null">
                    <span class="nav-link-in">
                      Carga
                      <i class="fa fa-truck"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t7'+rowData.cotacao_id+''" role="tab" data-toggle="tab" v-if="rowData.cotacao_valor!==null">
                    <span class="nav-link-in">
                      Valores
                      <i class="fa fa-money"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t8'+rowData.cotacao_id+''" role="tab" data-toggle="tab" v-if="rowData.cotacao_regra_fiscal.length>0">
                    <span class="nav-link-in">
                      Regra Fiscal
                      <i class="fa fa-money"></i>
                    </span>
                  </a>
                </li>
			</ul>

			<div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t1'+rowData.cotacao_id+''">
                    <table class="table-striped" id="mais">
                          <thead>
                              <tr>
                                  <th style="width: 30%">Origem</th>
                                  <th style="width: 30%">Pessoa Destino</th>
                                  <th style="width: 20%">Data Aprovação</th>
                                  <th style="width: 20%">Data Cancelamento</th>
                              </tr>
                           </thead>
                           <tbody>
                               <tr class="bg-gray-light" style="display: table-row;" >
                                   <td>
                                       <span class="badge badge-success" v-if="rowData.origem.valor==1">{{ rowData.origem.descr }}</span>
                                       <span class="badge badge-warning" v-if="rowData.origem.valor==2">{{ rowData.origem.descr }}</span>
                                   </td>
                                   <td>
                                       <span v-if="rowData.pessoa_origem!==null && rowData.pessoa_destino.pessoa_fisica!==null">{{rowData.pessoa_destino.pessoa_fisica.nome}} - {{rowData.pessoa_destino.pessoa_fisica.cpf}}</span>
                                       <span v-if="rowData.pessoa_origem!==null && rowData.pessoa_destino.pessoa_juridica!==null">{{rowData.pessoa_destino.pessoa_juridica.razao_social}} CNPJ: {{onFormataCnpj(rowData.pessoa_destino.pessoa_juridica.cnpj_base,rowData.pessoa_destino.pessoa_juridica.cnpj_filial,rowData.pessoa_destino.pessoa_juridica.cnpj_digito)}} IE: {{rowData.pessoa_destino.pessoa_juridica.inscricao_estadual}}</span>
                                       <span v-if="rowData.pessoa_origem!==null && rowData.pessoa_destino.pessoa_exterior!==null">{{rowData.pessoa_destino.pessoa_exterior.nome}} - {{rowData.pessoa_destino.pessoa_exterior.cd}}</span>
                                   </td>
                                   <td>
                                       <span v-if="rowData.dt_aprovacao!==null">{{formatDate(rowData.dt_aprovacao)}} por {{rowData.usuario_aprov.pessoa.pessoa_fisica.nome}}</span>
                                   </td>
                                   <td>
                                       <span v-if="rowData.dt_cancelamento!==null">{{formatDate(rowData.dt_cancelamento)}} por {{rowData.usuario_canc.pessoa.pessoa_fisica.nome}}</span>
                                   </td>
                              </tr>
                         </tbody>
                      </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t2'+rowData.cotacao_id+''" v-if="rowData.obs!==null">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 100%">Observação</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{rowData.obs}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t3'+rowData.cotacao_id+''" v-if="rowData.cotacao_trecho.length>0">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 10%">Ordem</th>
                                <th style="width: 20%">Tabela de Frete</th>
                                <th style="width: 10%">Tipo Serviço</th>
                                <th style="width: 10%">Tipo Pedido</th>
                                <th style="width: 10%">Tipo Trecho</th>
                                <th style="width: 20%">Tipo Coleta/Entrega</th>
                                <th style="width: 10%">Modal</th>
                                <th style="width: 10%">Ações</th>
                            </tr>
                         </thead>
                         <tbody v-for="item in rowData.cotacao_trecho">
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{item.ordem}}
                                </td>
                                <td>
                                    <span v-if="item.tabela_frete_vigencia!==null">{{item.tabela_frete_vigencia.tabela_frete.descr}}</span>
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="item.tp_servico.valor==0">{{ item.tp_servico.descr }}</span>
                                    <span class="badge badge-info" v-if="item.tp_servico.valor==1">{{ item.tp_servico.descr }}</span>
                                    <span class="badge badge-secondary" v-if="item.tp_servico.valor==2">{{ item.tp_servico.descr }}</span>
                                    <span class="badge badge-primary" v-if="item.tp_servico.valor==3">{{ item.tp_servico.descr }}</span>
                                    <span class="badge badge-warning" v-if="item.tp_servico.valor==4">{{ item.tp_servico.descr }}</span>
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="item.tp_pedido.valor==1">{{ item.tp_pedido.descr }}</span>
                                    <span class="badge badge-danger" v-if="item.tp_pedido.valor==2">{{ item.tp_pedido.descr }}</span>
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="item.tp_trecho.valor==1">{{ item.tp_trecho.descr }}</span>
                                    <span class="badge badge-warning" v-if="item.tp_trecho.valor==2">{{ item.tp_trecho.descr }}</span>
                                    <span class="badge badge-danger" v-if="item.tp_trecho.valor==3">{{ item.tp_trecho.descr }}</span>
                                </td>
                                <td>
                                    <span class="badge badge-success" v-if="item.tp_coleta_entrega.valor==1">{{ item.tp_coleta_entrega.descr }}</span>
                                    <span class="badge badge-danger" v-if="item.tp_trecho.valor==2">{{ item.tp_trecho.descr }}</span>
                                </td>
                                <td>
                                    {{item.b_modal.descr}}
                                </td>
                                <td>
                                  <a @click="onDetailTrecho(item)" v-b-tooltip title="Ver detalhes"><i class="fa fa-plus"></i></a>
                                </td>
                            </tr>
                            <tr v-if="isVisibleDetailRow(item.cottre_id)">
                                <td colspan="9">
                                    <ul class="nav nav-tabs nav-topline nav-justified" role="tablist">
                                      <li class="nav-item">
                                        <a class="nav-link active" v-bind:href="'#tr1'+item.cottre_id+''" role="tab" data-toggle="tab">
                                          <span class="nav-link-in">
                                            Detalhes Origem
                                            <i class="fa fa-paper-plane"></i>
                                          </span>
                                        </a>
                                      </li>
                                      <li class="nav-item">
                                        <a class="nav-link" v-bind:href="'#tr2'+item.cottre_id+''" role="tab" data-toggle="tab">
                                          <span class="nav-link-in">
                                            Detalhes Destino
                                            <i class="fa fa-paper-plane-o"></i>
                                          </span>
                                        </a>
                                      </li>
                                      <li class="nav-item">
                                        <a class="nav-link" v-bind:href="'#tr3'+item.cottre_id+''" role="tab" data-toggle="tab" v-if="item.obs!==null">
                                          <span class="nav-link-in">
                                            Observação
                                            <i class="fa fa-comment"></i>
                                          </span>
                                        </a>
                                      </li>
                                      <li class="nav-item">
                                        <a class="nav-link" v-bind:href="'#tr4'+item.cottre_id+''" role="tab" data-toggle="tab" v-if="item.cotacao_trecho_custo.length>0">
                                          <span class="nav-link-in">
                                            Custo
                                            <i class="fa fa-money"></i>
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  <div class="tab-content">
                                  <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'tr1'+item.cottre_id+''">
                                    <table :class="['vuetable table table-striped tbl-typical']">
                                    <thead>
                                      <tr>
                                          <th style="width: 25%">CEP</th>
                                          <th style="width: 25%">Município</th>
                                          <th style="width: 25%">Endereço</th>
                                          <th style="width: 25%">Complemento</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                          <tr class="bg-gray-light" style="display: table-row;">
                                             <td>
                                                 {{ item.cep_origem }}
                                             </td>
                                             <td>
                                                 {{ item.municipio_origem.nome }}
                                             </td>
                                             <td>
                                                 {{ item.endereco_ori }}
                                             </td>
                                             <td>
                                                 {{ item.endereco_ori_compl }}
                                             </td>
                                         </tr>
                                       </tbody>
                                    </table>
                                  </div>
                                  <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'tr2'+item.cottre_id+''">
                                    <table :class="['vuetable table table-striped tbl-typical']">
                                    <thead>
                                      <tr>
                                          <th style="width: 25%">CEP</th>
                                          <th style="width: 25%">Município</th>
                                          <th style="width: 25%">Endereço</th>
                                          <th style="width: 25%">Complemento</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                          <tr class="bg-gray-light" style="display: table-row;">
                                             <td>
                                                 {{ item.cep_destino }}
                                             </td>
                                             <td>
                                                 {{ item.municipio_destino.nome }}
                                             </td>
                                             <td>
                                                 {{ item.endereco_des }}
                                             </td>
                                             <td>
                                                 {{ item.endereco_des_compl }}
                                             </td>
                                         </tr>
                                       </tbody>
                                    </table>
                                  </div>
                                  <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'tr3'+item.cottre_id+''">
                                    <table :class="['vuetable table table-striped tbl-typical']">
                                    <thead>
                                      <tr>
                                          <th style="width: 100%">Observação</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                          <tr class="bg-gray-light" style="display: table-row;">
                                             <td>
                                                 {{ item.obs }}
                                             </td>
                                         </tr>
                                       </tbody>
                                    </table>
                                  </div>
                                  <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'tr4'+item.cottre_id+''" v-if="item.cotacao_trecho_custo.length>0">
                                    <table :class="['vuetable table table-striped tbl-typical']">
                                    <thead>
                                      <tr>
                                          <th style="width: 5%">Custo</th>
                                          <th style="width: 5%">CST</th>
                                          <th style="width: 5%">% Desc.</th>
                                          <th style="width: 5%">Sim. Aliquota</th>
                                          <th style="width: 5%">Sim. CST</th>
                                          <th style="width: 5%">Sim. Perc. redução BC</th>
                                          <th style="width: 5%">Sim. vlr. BC ST retido</th>
                                          <th style="width: 5%">Sim. vlr. crédito presumido</th>
                                          <th style="width: 10%">Sim. vlr. imposto ST retido</th>
                                          <th style="width: 10%">Sim. vlr. total</th>
                                          <th style="width: 10%">Vlr. desc.</th>
                                          <th style="width: 10%">Vlr. imposto</th>
                                          <th style="width: 10%">Vlr. taxa</th>
                                          <th style="width: 10%">Vlr. total</th>
                                      </tr>
                                      </thead>
                                      <tbody>
                                          <tr class="bg-gray-light" style="display: table-row;" v-for="item2 in item.cotacao_trecho_custo">
                                             <td>
                                                 {{ item2.custo.descr }}
                                             </td>
                                             <td>
                                                 CST
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.perc_desconto)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.simula_aliquota)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.simula_cst)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.simula_perc_reducao_bc)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.simula_vlr_bc_st_retido)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.simula_vlr_credito_presumido)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.simula_vlr_imposto_st_retido)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.simula_vlr_total)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.vlr_desconto)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.vlr_imposto)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.vlr_taxa)}}
                                             </td>
                                             <td>
                                                 {{formatNumber(item2.vlr_total)}}
                                             </td>
                                         </tr>
                                       </tbody>
                                    </table>
                                  </div>
                                </div>
                            </td>
                          </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t4'+rowData.cotacao_id+''">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 10%">Tipo</th>
                                <th style="width: 45%">Chave CTE</th>
                                <th style="width: 45%">Chve NFE</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.cotacao_doc">
                                <td>
                                    {{item.tp_doc.descr}}
                                </td>
                                <td>
                                    {{item.chave_cte}}
                                </td>
                                <td>
                                    {{item.chave_nfe}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t5'+rowData.cotacao_id+''" v-if="rowData.cotacao_contato.length>0">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 34%">Nome</th>
                                <th style="width: 33%">Email</th>
                                <th style="width: 33%">Telefone</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.cotacao_contato">
                                <td>
                                    {{item.nome}}
                                </td>
                                <td>
                                    {{item.email}}
                                </td>
                                <td>
                                    {{item.telefone}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t6'+rowData.cotacao_id+''" v-if="rowData.cotacao_carga!==null">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 25%">Peso Cubado</th>
                                <th style="width: 25%">Peso Declarado</th>
                                <th style="width: 25%">Peso Utilizado</th>
                                <th style="width: 25%">Qtde. Volume</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{formatNumber(rowData.cotacao_carga.peso_cubado)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_carga.peso_declarado)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_carga.peso_utilizado)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_carga.qtde_volume)}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t7'+rowData.cotacao_id+''" v-if="rowData.cotacao_valor!==null">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 5%">CST</th>
                                <th style="width: 5%">Tipo CST</th>
                                <th style="width: 5%">% Desc.</th>
                                <th style="width: 5%">Valor Desc.</th>
                                <th style="width: 5%">Aliquota</th>
                                <th style="width: 5%">Vlr. frete</th>
                                <th style="width: 10%">Vlr. imposto</th>
                                <th style="width: 10%">Vlr. outros</th>
                                <th style="width: 10%">%. redução BC</th>
                                <th style="width: 10%">Vlr. BC ST Retido</th>
                                <th style="width: 10%">Vlr. crédito presumido</th>
                                <th style="width: 10%">Vlr. total NFE</th>
                                <th style="width: 10%">Vlr. total</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;">
                                 <td>
                                     {{rowData.cotacao_valor.cst}}
                                 </td>
                                 <td>
                                     CST
                                 </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.perc_desconto)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.vlr_desconto)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.aliquota)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.vlr_frete)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.vlr_imposto)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.vlr_outros)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.perc_reducao_bc)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.vlr_bc_st_retido)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.vlr_bc_st_presumido)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.vlr_total_nfe)}}
                                </td>
                                <td>
                                    {{formatNumber(rowData.cotacao_valor.vlr_total)}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade pt-1 border-color-detalhes-grey" v-bind:id="'t8'+rowData.cotacao_id+''" v-if="rowData.cotacao_regra_fiscal.length>0">
                    <table class="table-striped" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 10%">Ordem</th>
                                <th style="width: 90%">Regra Fiscal</th>
                            </tr>
                         </thead>
                         <tbody>
                             <tr class="bg-gray-light" style="display: table-row;" v-for="item in rowData.cotacao_regra_fiscal">
                                 <td>
                                     {{item.ordem}}
                                 </td>
                                 <td>
                                     {{item.regra_fiscal.descr}}
                                 </td>
                            </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
</template>
<script>
    import accounting from 'accounting'
    import moment from 'moment'

    export default {
      data () {
        return {
          visibleDetailRows: [],
          helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        onReloadVuetable() {
            this.$refs.vuetable.reload();
        },
        isVisibleDetailRow (rowId) {
          return this.visibleDetailRows.indexOf( rowId ) >= 0
        },
        showDetailRow (rowId) {
          if (!this.isVisibleDetailRow(rowId)) {
            this.visibleDetailRows.push(rowId)
          }
        },
        hideDetailRow (rowId) {
          if (this.isVisibleDetailRow(rowId)) {
            this.visibleDetailRows.splice(
              this.visibleDetailRows.indexOf(rowId),
              1
            )
          }
        },
        toggleDetailRow (rowId) {
          if (this.isVisibleDetailRow(rowId)) {
            this.hideDetailRow(rowId)
          } else {
            this.showDetailRow(rowId)
          }
        },
        onDetailTrecho(data) {
          this.toggleDetailRow(data.cottre_id);
        },
      onActivateDesactivate(action, data, tipo)
      {
          // Tipo = true = Checkbox
          if(tipo)
          {
              this.helpForm.statusRecord = [];
              this.helpForm.statusRecord.push({ id: data.cfonatali_id, status: action, origem: 2 });
          }
          else
          {
              this.helpForm.statusRecord = [];
              this.$refs.vuetable.selectedTo.forEach((obj)=>{
                  this.helpForm.statusRecord.push({ id: obj, status: action, origem: 2 })
              });
          }

          this.helpForm.post('/api/cfop/status').then(response =>
          {
              new ReturnApi(response, this);
              Event.$emit('reloadVuetable', data);
          })
          .catch(errors =>
          {
              new ReturnApi(errors, this)
          });

      },
      formatDate (value, fmt = 'DD/MM/YYYY') {
        return (value == null)
          ? ''
          : moment(value, 'YYYY-MM-DD').format(fmt)
      },
      onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        var cnpj_formatado
        var pad = "00000000";
        var cnpj_base = pad.substring(0, pad.length - cnpj_base.toString().length) + cnpj_base;
        var pad = "0000"
        var cnpj_filial = pad.substring(0, pad.length - cnpj_filial.toString().length) + cnpj_filial;
        var pad = "00"
        var cnpj_digito = pad.substring(0, pad.length - cnpj_digito.toString().length) + cnpj_digito;
        return cnpj_base + "" + cnpj_filial + "" + cnpj_digito;
      },
    },

  }
  </script>
